<template>
  <NuxtLayout v-if="dataApiList.success" name="standard">
    <ConnectifTag :name="CONNECTIF_PAGE_TAGS.OTHERS" />
    <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.OTHERS" />
    <SSection v-if="randomImage" :has-separator="false" :mobile-full="true">
      <SHeroCardSearch
        :image="randomImage"
        :title="t('landings.holidays-list.title')"
      />
    </SSection>

    <SSection
      :title="t('landings.holidays-list.subtitle')"
      centered
      :has-separator="false"
    >
      <div class="grid gap-4 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
        <UCard
          v-for="(item, index) in dataApiList.success.data"
          :key="index"
          as="a"
          :ui="cardFiveFlexibleWithBorder"
          :href="routes().holidaysDetail({ slug: item.attributes.slug })"
        >
          <TLazyimg
            :src="item.attributes.img.data.attributes.formats.thumbnail.url"
            alt=""
            classes-img="object-cover w-full h-full rounded-t-lg group-hover:opacity-80 transition ease-in-out duration-300"
            classes="aspect-w-7 aspect-h-6"
          />
          <template #footer>
            <TText tag="h3" variant="semibold" clamp="clamp1" classes="mb-0">
              {{ item.attributes.name }}
            </TText>
          </template>
        </UCard>
      </div>
    </SSection>

    <SSpacer />
  </NuxtLayout>
</template>

<script setup lang="ts">
// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Composables
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'

// Config
import { cardFiveFlexibleWithBorder } from '~~/modules/design-system/utils/nuxt-ui-config/components/card'

// APIs
import getHolidaysList from '~~/modules/api/strapi/vacaciones-landings/list'

const { setHeadInfo } = useHeadInfoComposable()

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const dataApiList = await getHolidaysList()

let randomImage: string

if (dataApiList.success) {
  setHeadInfo({
    title: t('landings.holidays-list.seo.title'),
    description: t('landings.holidays-list.seo.description'),
    robotsVisible: true,
  })

  const breadCrumbMenuStore = useMenuBreadcrumbStore()
  breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.holidays'))

  if (dataApiList.success.data.length > 0) {
    const randomIndex = Math.floor(
      Math.random() * dataApiList.success.data.length,
    )
    randomImage =
      dataApiList.success.data[randomIndex].attributes.img.data.attributes.url
  }
} else if (dataApiList.error) {
  showErrorPage(dataApiList.error as ApiResponseError)
}

sendConnectifPage()
</script>
